const mediaItems = [
  {
    title: '黑料深度解析：某顶流塌房事件全时间线回顾',
    duration: '15:42',
    views: '12.8万',
    tag: '深度解析',
    img: 'https://readdy.ai/api/search-image?query=Dark%20documentary%20style%20image%2C%20timeline%20visualization%20concept%2C%20dramatic%20red%20and%20charcoal%20tones%2C%20investigative%20journalism%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20abstract%20data%20visualization%20in%20dark%20setting&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '瓜田风向标：本周最值得关注的五大黑料事件',
    duration: '08:25',
    views: '9.6万',
    tag: '每周精选',
    img: 'https://readdy.ai/api/search-image?query=Dark%20news%20studio%20setup%20with%20warm%20accent%20lighting%2C%20professional%20broadcast%20atmosphere%2C%20empty%20desk%20with%20microphone%2C%20cinematic%20mood%2C%20low%20key%20lighting%2C%20no%20people%2C%20editorial%20photography&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '黑料故事会：互联网大厂十年恩怨史',
    duration: '22:10',
    views: '18.3万',
    tag: '长篇故事',
    img: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20storytelling%20concept%2C%20silhouette%20of%20empty%20office%20buildings%20at%20night%2C%20dramatic%20red%20and%20dark%20tones%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20low%20key%20photography&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '吃瓜快讯：24小时黑料热点速览',
    duration: '05:30',
    views: '15.7万',
    tag: '每日快讯',
    img: 'https://readdy.ai/api/search-image?query=Dark%20digital%20news%20display%20concept%2C%20multiple%20screens%20showing%20abstract%20data%20in%20dark%20room%2C%20warm%20accent%20glow%2C%20modern%20media%20aesthetic%2C%20no%20recognizable%20content%2C%20low%20key%20atmosphere&width=800&height=500&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          黑料视觉
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          精选黑料故事视频解读，沉浸式吃瓜体验
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 border border-background-200/60 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-500/30"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-xl text-white ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block text-xs text-primary-400 bg-primary-500/10 px-2 py-0.5 rounded-full mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm font-medium text-foreground-200 line-clamp-2 mb-2 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.views} 次观看</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}